import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const RevenueDashboard = () => {
  return <DashboardPageTemplate pageName={"revenue"} />;
};
